export type StripeObject = {
  stripeCustomerId: string;
  stripeSubscriptionId: string;
  stripeAccountId: string;
  defaultCurrency: string;
};

export type CompanyAccount = {
  _id: string;
  name: string;
  email: string;
};

export type CompanyAddress = {
  __typename?: string;
  address1: string;
  address2: string;
  city: string;
  postCode: string;
  country: string;
  state: string;
};
export type CompanyType = {
  _id: string;
  name: string;
  accountId: CompanyAccount;
  stripe: StripeObject;
  address: CompanyAddress;
  shipping: CompanyAddress;
};

export interface GetCompaniesResponse {
  companies: CompanyType[];
}

export enum Libraries {
  OPEN = 'open',
  SEMI_LOCKED = 'semi_locked',
  LOCKED = 'locked',
}

export enum Billings {
  SELF = 'self',
  ORG = 'org',
}

export enum CompanyLinks {
  DASHBOARD = 'dashboard',
  PROFILE = 'profile',
  PLAN = 'plan',
  SUBSCRIPTIONS = 'subscriptions',
  HISTORY = 'history',
  ORDERS = 'orders',
  SETTINGS = 'settings',
  PRICING = 'pricing',
}
